/* eslint-disable unicorn/prefer-module */
/* eslint-disable max-len */
/* eslint-disable prettier/prettier */
import { useCallback } from "react";

export const useVFFormatting = (pais, getDolarValue, dolarFallback) => {
  const localString = useCallback(
    (pais) =>
      ({
        Chile: "es-CL",
        Perú: "es-PE",
      })[pais] || "es-CL",
    []
  );
  const moneda = useCallback(
    (pais) =>
      ({
        Chile: "$",
        Perú: "S/",
      })[pais] || "$",
    []
  );
  const decimales = useCallback(
    (pais) =>
      ({
        Chile: 0,
        Perú: 2,
      })[pais] || 0,
    []
  );
  const getRateForOportunidad = useCallback(
    (oportunidad) => {
      if (!oportunidad.moneda_dolar) return 1;
      const fecha = oportunidad.facturafecha;
      return fecha ? getDolarValue(fecha) : (dolarFallback[pais] || 1);
    },
    [getDolarValue, dolarFallback, pais]
  );

  // Rate del dólar para una fecha (independiente de moneda_dolar)
  const getDolarRateForDate = useCallback(
    (facturafecha) => facturafecha ? getDolarValue(facturafecha) : (dolarFallback[pais] || 1),
    [getDolarValue, dolarFallback, pais]
  );

  const mesEnLetras = useCallback((mes) => {
    const mesesEnLetras = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
    return mesesEnLetras[parseInt(mes, 10) - 1] || "";
  }, []);

  const resolverNombreIntermediario = useCallback((intermediarioId, intermediarios) => {
    if (!intermediarioId) return "SIN INTERMEDIARIO";
    const intermediarioAsociado = intermediarios.find(
      (i) => i.id === parseInt(intermediarioId, 10)
    );
    return intermediarioAsociado ? intermediarioAsociado.nombre : "SIN INTERMEDIARIO";
  }, []);

  // FUNCIÓN SEGURA
  const fechaLocal = (fechaISO) => {
    if (!fechaISO) return null;
    const [y, m, d] = fechaISO.split("T")[0].split("-");
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
  };

  const hoy = fechaLocal(new Date().toISOString().split("T")[0]);
  const mesActual = (new Date().getMonth() + 1).toString().padStart(2, "0");
  const anoActual = new Date().getFullYear().toString();
  const fecha = { day: "2-digit", month: "2-digit", year: "numeric" };

  const esCuotaEditable = (mes, ano) => {
    if (!mes || !ano) return false;
    const anoNum = parseInt(ano, 10);
    const mesNum = parseInt(mes, 10);
    const anoActNum = parseInt(anoActual, 10);
    const mesActNum = parseInt(mesActual, 10);
    return anoNum < anoActNum || (anoNum === anoActNum && mesNum <= mesActNum);
  };

  const getEstadoCobro = (facturafecha, facturafechacobro, plazocobro, vinculadaSII = false) => {
    const fechaCobro = facturafechacobro ? fechaLocal(facturafechacobro) : null;
    const fechaPlazo = plazocobro ? fechaLocal(plazocobro) : null;
    const tieneFactura = !!facturafecha || vinculadaSII;

    // 1. COBRADA (confirmada por movimiento bancario) → VERDE OSCURO
    if (fechaCobro && fechaCobro <= hoy) {
      return { bg: "#1a5632", text: fechaCobro.toLocaleDateString("es-ES", fecha), cobrada: true };
    }

    // 2. COBRO FUTURO (registrado pero aún no llegó) → ROJO
    if (fechaCobro && fechaCobro > hoy) {
      return { bg: "#dc3545", text: fechaCobro.toLocaleDateString("es-ES", fecha), cobrada: false };
    }

    // 3. FACTURADA/VINCULADA, CON FECHA ESTIMADA → AZUL OSCURO + plazocobro
    if (tieneFactura && fechaPlazo) {
      return { bg: "#2c3e50", text: fechaPlazo.toLocaleDateString("es-ES", fecha), cobrada: false };
    }

    // 4. FACTURADA/VINCULADA, SIN FECHA → ROJO + "Registrar"
    if (tieneFactura) {
      return { bg: "#dc3545", text: "Registrar", cobrada: false };
    }

    // 5. SIN FACTURAR NI VINCULAR
    return { bg: "#4c5257", text: "Sin facturar", cobrada: false };
  };

  return {
    localString,
    moneda,
    decimales,
    getRateForOportunidad,
    getDolarRateForDate,
    mesEnLetras,
    resolverNombreIntermediario,
    fechaLocal,
    esCuotaEditable,
    getEstadoCobro,
    hoy,
    fecha,
  };
};
